export default __webpack_public_path__ + "static/media/fundoFlor2.edc8f0e0.png";